export default __webpack_public_path__ + "dist/media/PencilSky.a1a5bbc7.svg";